const urlName = 'saas/v1/lvjian/user'

export default API => ({
    //绿建-判断用户是否已完善个人资料
    checkSaveDetail(data) {
        return API({
            url: `${urlName}/checkSaveDetail` ,
            method:  'get',
            data
        });
    },

    //绿建-查询学员信息
    queryUserInfoBycn(data) {
        return API({
            url: `${urlName}/queryUserInfoByc` ,
            method:  'get',
            data
        });
    },
    //绿建-查询学员是否实名
    accountProfileByAccountId(data){
        return API({
            url: `${urlName}/accountProfileByAccountId` ,
            method:  'get',
            data
        });
    },
    //绿建-学员修改
    updateBycUserId(data){
        return API({
            url: `${urlName}/updateBycUserId` ,
            method:  'post',
            data
        });
    }

})

